import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ddb8c90a"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=ddb8c90a&prod&lang=scss&scope=true"
import style1 from "./Footer.vue?vue&type=style&index=1&id=ddb8c90a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports